import styled from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
const close = '/static/images/menu/close.svg';

export const Wrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: ${({ isSideBar }) => isSideBar ? 'flex-start' : 'center'};
    font-family: 'robotoLight', Arial, Helvetica, sans-serif;
    line-height: 1.33;
    font-size: 16px;
    padding-right: ${({ isSideBar }) => isSideBar ? '30px' : '84px'};
    margin-bottom: 12px;
    color: ${COLORS.black};
    position: relative;
    flex-direction: ${({ isSideBar }) => isSideBar ? 'column' : 'row'};
    @media(max-width: 530px) {
        flex-direction: column;
        align-items: flex-start;
        padding-right: 30px;
    }
`;

export const Text = styled.div`
    display: block;
    width: ${({ isSideBar }) => isSideBar ? '100%' : 'calc(100% - 128px)'};
    padding-bottom: ${({ isSideBar }) => isSideBar ? '5px' : '0'};
    padding-left: ${ ({ isPadding }) => isPadding ? '20px' : 'unset'};
    @media(max-width: 530px) {
        width: 100%;
        padding-bottom: 5px;
        padding-left: 0;
    }
`;

export const Price = styled.div`
    display: flex;
    width: ${({ isSideBar }) => isSideBar ? 'auto' : '128px'};
    justify-content: center;
    align-items: ${({ isSideBar }) => isSideBar ? 'flex-start' : 'flex-end'};
    color: ${COLORS.darkGrey};
    @media(max-width: 530px) {
        width: auto;
        align-items: flex-start;
    }
`;

export const PriceNumber = styled.div`
    display: block;
    width: ${({ isSideBar }) => isSideBar ? 'auto' : '80px'};
    text-align: ${({ isSideBar }) => isSideBar ? 'left' : 'right'};
    padding-right: 5px;
    @media(max-width: 530px) {
        width: auto;
        text-align: left;
    }
`;

export const OldPrice = styled.span`
    display: inline;
    color: ${COLORS.grey}
    font-size: 14px;
    text-decoration: line-through;
    padding-right: 2px;
`;

export const PriceText = styled.div`
    display: block;
    width: 48px;
`;

export const Delete = styled.div`
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 10px;
    margin: auto 0;
    width: 24px;
    height: 24px;
    cursor: pointer;
    path {
        stroke: ${COLORS.grey};
    }
    @media (max-width: 1023px) {
        bottom: auto;
    }
`;

export const CheckBox = styled.div`
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 10px;
    margin: auto 0;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: 1px solid ${({ selected }) => selected ? COLORS.lightGreen : COLORS.grey};
    cursor: pointer;
    background-color: ${({ selected }) => selected ? COLORS.lightGreen : COLORS.white};
    &:after {
        display: block;
        position: absolute;
        content: '';
        width: 10px;
        height: 3px;
        top: 0;
        left: 1px;
        right: 0;
        bottom: 4px;
        border-bottom: 1px solid ${COLORS.white};
        border-left: 1px solid ${COLORS.white};
        transform: rotate(-45deg);
        margin: auto;
    }
`;

export const Tooltip = styled.div`
    display: block;
    position: absolute;
    left: calc(100% + 22px);
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
    top: 50%;
    transform: translateY(-50%);
    font-size: 16px;
    color: ${COLORS.white};
    background: #515B60;
    border-radius: 4px;
    font-family: 'robotoRegular', Arial, Helvetica, sans-serif;
    width: 312px;
    padding: 20px;
    z-index: 2;
    line-height: 1.4;
    transition: 0.5s;
    white-space: normal;
    align-self: center;
    &:after {
        display: block;
        content: '';
        position: absolute;
        left: -5px;
        top: calc(50% - 5px);
        width: 10px;
        height: 10px;
        background: #515B60;
        margin: 0 auto;
        transform: rotate(45deg);
    }
    @media (max-width: 1023px) {
        transform: none;
        top: auto;
        position: relative;
        max-width: 480px;
        width: 100%;
        left: 0;
        margin-top: 10px;
        &:after {
            left: 20px;
            top: -5px;
        }
    }
    @media(max-width: 600px) {
        padding: 16px 30px;
        width: calc(100% + 30px);
    }
`;

export const Close = styled.div`
    content: '';
    color: #000;
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 10px;
    width: 15px;
    height: 15px;
    background: url(${close}) center / contain no-repeat;
    z-index: 10;
    @media (max-width: 906px) {
        top: 50%;
        transform: translateY(-50%);
        right: 15px;
    }
    
`;
